"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHu_const_cloudfront_baseUrls = void 0;
exports.SHu_const_cloudfront_baseUrls = {
    main: "https://dyaj6jwzih5dm.cloudfront.net",
};
